import { render, staticRenderFns } from "./expoCar.vue?vue&type=template&id=60f762b2&scoped=true"
import script from "./expoCar.vue?vue&type=script&lang=js"
export * from "./expoCar.vue?vue&type=script&lang=js"
import style0 from "./expoCar.vue?vue&type=style&index=0&id=60f762b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f762b2",
  null
  
)

export default component.exports